export const baseUrl =
  process.env.NODE_ENV == "development"
    ? "https://dermoparkvip.xyz/api/"
    : "/api/";

export const pageTitle = 'Lezzet Döner';
export const imageBase =
  process.env.NODE_ENV == "development"
    ? "https://dermoparkvip.xyz/"
    : "https://dermoparkvip.xyz/";

